import {DateTime} from 'luxon';
import ObjectStatus from '../enums/static/ObjectStatus';
import {
  DataSource,
  DataSourceStatistics,
  PixelData,
  RemoteDataSource,
  RemoteDataSourceStatistics,
} from './dataSources.types';

export function toClientDataSource(dataSource: RemoteDataSource): DataSource {
  return {
    ...dataSource,
    isActive: dataSource.status === ObjectStatus.Active,
    creation: DateTime.fromISO(dataSource.creation),
  };
}

export function toDataSourceStatisticsPixelData(pixelData: PixelData): DataSourceStatistics {
  return {
    date: null as unknown as DateTime,
    countPerEventType: pixelData?.eventToCountDic,
    datasourceId: +pixelData.pixelId,
    totalCount: pixelData.totalEventCount,
    name: pixelData.name,
    timeToEventCountDic: pixelData.timeToEventCountDic,
    timeToTotalEventDic: pixelData.timeToTotalEventDic,
    eventToParametersRecievedCounts: pixelData.eventToParametersRecievedCounts,
  };
}

export function toClientDataSourceStatistics(
  remoteStats: RemoteDataSourceStatistics,
): DataSourceStatistics {
  return {
    ...remoteStats,
    date: DateTime.fromISO(remoteStats.date),
  };
}
